import { render, staticRenderFns } from "./overflowTooltip.vue?vue&type=template&id=4b552cd8&scoped=true"
import script from "./overflowTooltip.vue?vue&type=script&lang=js"
export * from "./overflowTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b552cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b552cd8')) {
      api.createRecord('4b552cd8', component.options)
    } else {
      api.reload('4b552cd8', component.options)
    }
    module.hot.accept("./overflowTooltip.vue?vue&type=template&id=4b552cd8&scoped=true", function () {
      api.rerender('4b552cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/overflowTooltip.vue"
export default component.exports